import { useState } from "react";
import type { SpaceType } from "@circle-react/types/Space";
import type { SpacePrefillData } from "../../../SettingsApp/Spaces/helpers/spacePrefillHelpers";

interface UseSpaceTypePickerStateParams {
  prefillData?: SpacePrefillData;
  selectedPostType?: SpaceType;
}

export const useSpaceTypePickerState = ({
  prefillData,
  selectedPostType,
}: UseSpaceTypePickerStateParams) => {
  const prefillCourseType =
    prefillData && "course_type" in prefillData
      ? prefillData.course_type
      : null;
  const isCoursePrefilled = !!prefillCourseType;

  const [postType, setPostType] = useState(selectedPostType ?? "basic");
  const [hasSelectedSpaceType, setHasSelectedSpaceType] = useState(
    (selectedPostType && selectedPostType !== "course") || isCoursePrefilled,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isCourseSpace, setIsCourseSpace] = useState(
    selectedPostType === "course" && !isCoursePrefilled,
  );
  const [courseSetting, setCourseSetting] = useState<any>(
    prefillCourseType ? { course_type: prefillCourseType } : undefined,
  );

  return {
    postType,
    hasSelectedSpaceType,
    isLoading,
    isCourseSpace,
    courseSetting,
    setPostType,
    setHasSelectedSpaceType,
    setIsLoading,
    setIsCourseSpace,
    setCourseSetting,
  };
};
